export function convertMask(sourceCanvas: HTMLCanvasElement): string {
  if (!sourceCanvas) {
    return '';
  }

  // Создаём новый canvas такого же размера
  const newCanvas = document.createElement('canvas');
  newCanvas.width = sourceCanvas.width;
  newCanvas.height = sourceCanvas.height;

  const ctx = newCanvas.getContext('2d');
  if (!ctx) {
    return '';
  }

  // Копируем изображение
  ctx.drawImage(sourceCanvas, 0, 0);
  const imageData = ctx.getImageData(0, 0, newCanvas.width, newCanvas.height);
  const data = imageData.data;

  for (let i = 0; i < data.length; i += 4) {
    const alpha = data[i + 3];

    if (alpha === 0) {
      // Прозрачный → чёрный
      data[i] = 0;
      data[i + 1] = 0;
      data[i + 2] = 0;
      data[i + 3] = 255;
    } else {
      // Остальные → белый
      data[i] = 255;
      data[i + 1] = 255;
      data[i + 2] = 255;
      data[i + 3] = 255;
    }
  }

  ctx.putImageData(imageData, 0, 0);
  return newCanvas.toDataURL(); // не трогаем оригинал
}
